import { useMsal } from "@azure/msal-react";
import { useCallback } from "react";
import { config } from "../config";

export const useEventsApi = () => {
  const { instance } = useMsal();

  const callApi = useCallback(
    async (
      endpoint: string,
      method = "GET",
      body?: any,
      isMultipart = false
    ) => {
    const account = instance.getActiveAccount();
    if (!account) {
      console.warn("Kein Benutzer eingeloggt – Token kann nicht geholt werden.");
      return;
    }

    try {
      const response = await instance.acquireTokenSilent({
        scopes: [config.loginRequestScope],
        account,
      });

      const accessToken = response.accessToken;

      const headers: HeadersInit = {
        Authorization: `Bearer ${accessToken}`,
      };

      if (!isMultipart) {
        headers["Content-Type"] = "application/json";
      }

      const apiResponse = await fetch(endpoint, {
        method,
        headers,
        cache: "no-store",
        body: isMultipart ? body : body ? JSON.stringify(body) : undefined,
      });

      const contentType = apiResponse.headers.get("Content-Type") || "";
      const contentDisposition = apiResponse.headers.get("Content-Disposition") || "";

      if (apiResponse.status === 304) {
        console.warn("304 Not Modified – returning empty array");
        return [];
      }

      if (!apiResponse.ok) {
        const errorText = await apiResponse.text();
        console.error(`API error ${apiResponse.status}:`, errorText);
        const error = new Error(`API error: ${apiResponse.status}`) as Error & {
          status?: number;
          responseBody?: string;
        };
        error.status = apiResponse.status;
        error.responseBody = errorText;
        throw error;
      }

      // File downloads (e.g. PDF) must stay binary; some proxies use generic types.
      if (
        contentDisposition.includes("attachment") ||
        contentDisposition.includes("filename=")
      ) {
        return await apiResponse.blob();
      }

      if (
        contentType.includes("application/zip") ||
        contentType.includes("application/octet-stream")
      ) {
        return await apiResponse.blob(); // <-- wichtig!
      }

      if (contentType.includes("application/xml")) {
        return await apiResponse.blob();
      }

      if (contentType.includes("application/pdf")) {
        return await apiResponse.blob();
      }

      if (contentType.includes("application/json")) {
        return await apiResponse.json();
      }

      // Fallback
      return await apiResponse.text();
    } catch (error) {
      console.error("API-Aufruf fehlgeschlagen:", error);
      throw error;
    }
  },
    [instance]
  );

  return { callApi };
};
